/**
 * Natulim DB | 28/01/2026 cambio: Sincronizador de Precios Reutilizable para STAY AI en main product y modal de la coleccion de todos los productos
 */

(function() {
  // 1. Hack Global de Moneda
  if (typeof Shopify !== 'undefined') {
    Shopify.formatMoney = function(cents) {
      if (typeof cents === 'string') cents = cents.replace(/[^0-9]/g, '');
      let price = (cents / 100).toFixed(2).replace('.', ',');
      return price + ' lei';
    };
  }

  // 2. Vigilante Inteligente
  window.initNatulimPriceObserver = function(container) {
    if (!container) return;
    const observer = new MutationObserver(() => {
      const btn = document.getElementById('dynamicPrice');
      if (btn && btn.textContent.includes('€')) {
        if (window.updateDynamicPrice) window.updateDynamicPrice();
      }
    });
    observer.observe(container, { childList: true, subtree: true });
  };

  // 3. Eventos Globales (Activados)
  document.addEventListener('variant:change', () => {
    setTimeout(() => { if (window.updateDynamicPrice) window.updateDynamicPrice(); }, 50);
  });
  
  document.addEventListener('natulimOptionValueChanged', () => {
    if (window.updateDynamicPrice) window.updateDynamicPrice();
  });
})();

